import type { CSSProperties } from 'react';

import Colors from '@rockalingua/ui/constants/Colors';

export const notificationStyle: CSSProperties = {
  width: 'auto',
  border: `1px solid ${Colors.NEUTRAL_VARIANTS[20]}`,
  padding: 16,
  borderRadius: 12,
};
